module.exports = "<div class=\"weui_cell_bd weui_cell_primary\"><slot></slot></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/cells/cell-body.vue
 ** module id = 67
 ** module chunks = 0
 **/